import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SignUpRoutingModule } from './sign-up-routing.module';
import { SignUpComponent } from './page/sign-up/sign-up.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { OtpSignUpComponent } from './page/otp-sign-up/otp-sign-up.component';
import { CoreModule } from 'src/app/core/core.module';
import { environment } from 'src/environments/environment';
import { VerifyNumberComponent } from './page/verify-number/verify-number.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoaderInterceptor } from 'src/app/core/interceptors/loader.interceptor';
import { TotpEnrollComponent } from './page/totp-enroll/totp-enroll.component';
import { SignUpV2Component } from './page/sign-up-v2/sign-up-v2.component';
import { EmailOtpVerifyComponent } from './page/email-otp-verify/email-otp-verify.component';
import { QRCodeModule } from 'angularx-qrcode';

@NgModule({
  declarations: [
    SignUpComponent,
    OtpSignUpComponent,
    VerifyNumberComponent,
    TotpEnrollComponent,
    SignUpV2Component,
    EmailOtpVerifyComponent
  ],
  imports: [
    CommonModule,
    SignUpRoutingModule,
    SharedModule,
    NgOtpInputModule,
    QRCodeModule,
    CoreModule.forRoot(environment)
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true }
  ]
})
export class SignUpModule {
 }
